import { FC } from "react";
import { Link } from "react-router";
import { CircleQuestionMark } from "lucide-react";

import { useAppSelector } from "../../store";
import { useAuth } from "../../auth";

import { CompaniesListDropdown } from "../Companies/CompaniesListDropdown";
import { SitesListDropdownAlt } from "../Sites/SitesListDropdownAlt";
import LogoIcon from "../../ui/assets/svg/vviinn-logo.svg?react";

import { TOP_MENU_ICON_WRAPPER } from "./styles";
import { vviinnLinkProps } from "./constants";
import { LARGE_ICON_SIZE_STYLES } from "../../ui/styles";
import { UserAvatar } from "../../user/UserAvatar";
import { ThemeSwitcher } from "../../ui/layout";

type HeaderProps = {
  showSelectors?: boolean;
  showLogo?: boolean;
};

export const Header: FC<React.PropsWithChildren<HeaderProps>> = ({
  showSelectors = true,
  showLogo = false,
}) => {
  const { user } = useAuth();
  const companyId = useAppSelector((state) => state.company.company?.id);

  return (
    <header>
      <div
        className={`flex h-16 ${
          !showLogo ? "justify-center" : ""
        } items-center bg-black px-4 dark:border-b dark:border-stone-900 dark:bg-black md:justify-between md:bg-stone-50`}
      >
        <a
          {...vviinnLinkProps}
          className={
            showLogo
              ? "md:-ml-4 md:flex md:h-16 md:w-64 md:items-center md:justify-center md:bg-black"
              : ""
          }
        >
          <LogoIcon
            width="112"
            height="28"
            className={`relative bottom-[3px] block ${
              showLogo ? "" : "md:hidden"
            } `}
          />
        </a>
        <div className="relative hidden flex-1 justify-center gap-3 md:inline-flex">
          {showSelectors && (
            <>
              <CompaniesListDropdown />
              <SitesListDropdownAlt />
            </>
          )}
        </div>

        <div className="absolute right-2 z-20 ml-3 flex items-center gap-0.5 sm:right-4 md:static md:right-0">
          {!!user && <UserAvatar />}
          {!!companyId && (
            <Link
              to={`/company/${companyId}/help`}
              id="Help"
              className={`${TOP_MENU_ICON_WRAPPER} sm:mr-3 md:ml-1 md:mr-0`}
              aria-label="help"
            >
              <CircleQuestionMark className={LARGE_ICON_SIZE_STYLES} />
            </Link>
          )}
          <div className={`${!!user ? "hidden " : ""} sm:inline-block`}>
            <ThemeSwitcher />
          </div>
        </div>
      </div>

      {showSelectors && (
        <div className="align-center flex justify-around gap-4 bg-stone-50 p-2 dark:border-b dark:border-stone-900 dark:bg-black md:hidden">
          <CompaniesListDropdown />
          <SitesListDropdownAlt />
        </div>
      )}
    </header>
  );
};
